var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('ProgressBar'),_c('NavBar',{on:{"clicked":function($event){_vm.drawer = !_vm.drawer}}}),_c('Content'),_c('Footer'),_c('Drawer',{model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }